import axiosInstance from "../lib/axios";

interface GetsubCategoryRequest {
  page?: number;
  limit?: number;
}

export const getsubCategory = async ({
  page = 1,
  limit = 10,
}: GetsubCategoryRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/SubCategory/List", body);

  return data;
};

export const createsubCategory = (data: {
  category_id: number;
  subcategory_name: string;
  status: string;
}) => {
  return axiosInstance.post("/SubCategory/Create", data);
};

export const getsubCategoryById = (id: number) => {
  return axiosInstance.get(`/SubCategory/Detail/${id}`);
};

export const getSubCategoryByCategory = (id: number) => {
  return axiosInstance.get(`/SubCategory/List/${id}`);
};


export const editsubCategory = (id: number, data: any) => {
  return axiosInstance.put(`/SubCategory/Edit/${id}`, data);
};

export const deletesubCategoryById = (id: number) => {
  return axiosInstance.delete(`/SubCategory/Delete/${id}`);
};

